/** @format */

"use client";

import { useEffect, useState } from "react";
import {
  Col,
  Form,
  Input,
  Row,
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  FormGroup,
  Label,
} from "reactstrap";
import {
  getVendorID,
  getVendorSettings,
  setVendorData,
} from "../../../services/helper";
import { toast } from "react-toastify";
import http from "../../../services/http";

export default function SettingForm() {
  const [tiers, setTiers] = useState([]);

  const [settings, setSettings] = useState({
    store_name: "",
    vendor_tax_rate: "",
    global_profit_margin_enabled: false,
    global_profit_margin_percentage: "",
    show_stock_on_frontend: false,
    vendor_return_policy:
      "90 day return accepted (Customer pays for return shipping)",
    vendor_contact_phone: "",
    vendor_contact_address: "",
    vendor_social_facebook: "",
    vendor_social_tiktok: "",
    vendor_social_twitter: "",
    vendor_social_youtube: "",

    ifields_key: "ifields_testdefaultdba325f488ccfde4a7b80d7b7ab",
    cardknox_api_key: "testdefaultdba7bc3b37fcb2043b38fbadf2af9e337bb",
    cardknox_api_key_override: false,
    points_usd_value: "",
    point_distribute_amount: "",
    receipt_print_option: "always",
    label_print_option: "always",

    customer_popup_checkout: false,

    allow_govt_discount: false,

    receiptTemplate: {
      showStoreName: false,
      showStorePhone: false,
      showSocialMedia: false,
      showStoreEmail: false,
      showStoreLogo: false,
      headerNote: "",
      footerNote: "",
    },
  });

  const return_policy_choices = {
    A: "90 day return accepted (Customer pays for return shipping)",
    B: "90 day return accepted with exceptions of (Customer pays for return shipping)",
    C: "90 day return accepted (Store pays for return shipping)",
    D: "90 day return accepted with exceptions of (Store pays for return shipping)",
    E: "No returns accepted",
    F: "Other",
  };

  useEffect(() => {
    async function loadSettings() {
      try {
        setSettings({
          store_name: getVendorSettings("store_name") || "",
          vendor_tax_rate: getVendorSettings("vendor_tax_rate") || "",
          global_profit_margin_enabled: getVendorSettings(
            "global_profit_margin_enabled"
          ),
          global_profit_margin_percentage:
            getVendorSettings("global_profit_margin_percentage") || "",
          show_stock_on_frontend:
            getVendorSettings("show_stock_on_frontend") === "true" || false,
          vendor_return_policy:
            getVendorSettings("vendor_return_policy") ||
            "90 day return accepted (Customer pays for return shipping)",
          vendor_contact_phone: getVendorSettings("vendor_contact_phone") || "",
          vendor_contact_address:
            getVendorSettings("vendor_contact_address") || "",
          vendor_social_facebook:
            getVendorSettings("vendor_social_facebook") || "",
          vendor_social_tiktok: getVendorSettings("vendor_social_tiktok") || "",
          vendor_social_twitter:
            getVendorSettings("vendor_social_twitter") || "",
          vendor_social_youtube:
            getVendorSettings("vendor_social_youtube") || "",

          ifields_key:
            getVendorSettings("ifields_key") ||
            "ifields_testdefaultdba325f488ccfde4a7b80d7b7ab",
          cardknox_api_key:
            getVendorSettings("cardknox_api_key") ||
            "testdefaultdba7bc3b37fcb2043b38fbadf2af9e337bb",
          cardknox_api_key_override:
            getVendorSettings("cardknox_api_key_override") === "true" || false,
          points_usd_value: getVendorSettings("points_usd_value") || "",
          point_distribute_amount:
            getVendorSettings("point_distribute_amount") || "",

          receipt_print_option:
            getVendorSettings("receipt_print_option") || "always",
          label_print_option:
            getVendorSettings("label_print_option") || "always",

          customer_popup_checkout:
            getVendorSettings("customer_popup_checkout") === true || false,

          allow_govt_discount:
            getVendorSettings("allow_govt_discount") === true || false,

          receiptTemplate: getVendorSettings("receiptTemplate") || {},
        });

        console.log(
          "setting",
          getVendorSettings("global_profit_margin_enabled")
        );

        // Load saved discount tiers
        const savedTiers =
          JSON.parse(getVendorSettings("discount_tier_by_points")) || [];
        setTiers(savedTiers);
      } catch (error) {
        console.error("Error loading settings:", error);
        toast.error("Could not load settings.");
      }
    }

    loadSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = {
      ...settings,
      discount_tier_by_points: JSON.stringify(tiers),
    };

    try {
      const response = await http.saveVendorData(data);
      toast.success("Settings saved successfully!");
      setVendorData(data);
    } catch (error) {
      console.error("Error saving settings:", error);
      toast.error("Failed to save settings. Please try again.");
    }
  };

  return (
    <Form className="needs-validation custom-input" onSubmit={handleSubmit}>
      {/* Original Settings Section */}
      <Row className="mb-4">
        <CardHeader>
          <CardTitle tag="h5">Store Settings</CardTitle>
        </CardHeader>
        <CardBody>
          <Row className="g-3">
            <Col sm={12}>
              <FormGroup row>
                <Label for="store_name" sm={3}>
                  Store Name
                </Label>
                <Col sm={9}>
                  <Input
                    id="store_name"
                    type="text"
                    placeholder="Enter Store Name"
                    name="store_name"
                    value={settings.store_name}
                    onChange={handleChange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="show_stock_frontend" sm={3}>
                  Show Stock on Frontend
                </Label>
                <Col sm={9}>
                  <FormGroup check>
                    <Input
                      type="checkbox"
                      id="show_stock_on_frontend"
                      name="show_stock_on_frontend"
                      checked={settings.show_stock_on_frontend}
                      onChange={handleChange}
                    />
                    <Label for="show_stock_on_frontend">
                      Enable to show stock on the product card on the frontend
                    </Label>
                  </FormGroup>
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="vendor_tax_rate" sm={3}>
                  Tax Rate
                </Label>
                <Col sm={9}>
                  <Input
                    id="vendor_tax_rate"
                    type="text"
                    placeholder="Enter Tax Rate"
                    name="vendor_tax_rate"
                    value={settings.vendor_tax_rate}
                    onChange={handleChange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="global_profit_margin_enabled" sm={3}>
                  Global Profit Margin
                </Label>
                <Col sm={9}>
                  <FormGroup check className="mb-2">
                    <Input
                      type="checkbox"
                      id="global_profit_margin_enabled"
                      name="global_profit_margin_enabled"
                      checked={settings.global_profit_margin_enabled}
                      onChange={handleChange}
                    />
                    <Label for="global_profit_margin_enabled">
                      Enable universal profit calculation (ignores individual
                      product costs)
                    </Label>
                  </FormGroup>
                  {settings.global_profit_margin_enabled && (
                    <Input
                      id="global_profit_margin_percentage"
                      type="number"
                      placeholder="Enter profit margin percentage (e.g., 60)"
                      name="global_profit_margin_percentage"
                      value={settings.global_profit_margin_percentage}
                      onChange={handleChange}
                      min="0"
                      max="100"
                      step="0.1"
                    />
                  )}
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="vendor_return_policy" sm={3}>
                  Return Policy
                </Label>
                <Col sm={9}>
                  {Object.entries(return_policy_choices).map(([key, value]) => (
                    <FormGroup check key={key}>
                      <Input
                        type="radio"
                        id={`vendor_return_policy_${key}`}
                        name="vendor_return_policy"
                        value={value}
                        checked={settings.vendor_return_policy === value}
                        onChange={handleChange}
                      />
                      <Label for={`vendor_return_policy_${key}`}>{value}</Label>
                    </FormGroup>
                  ))}
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="vendor_contact_phone" sm={3}>
                  Vendor Phone Number
                </Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="vendor_contact_phone"
                    id="vendor_contact_phone"
                    placeholder="Enter vendor phone number"
                    value={settings.vendor_contact_phone}
                    onChange={handleChange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="vendor_contact_address" sm={3}>
                  Vendor Address
                </Label>
                <Col sm={9}>
                  <Input
                    type="textarea"
                    name="vendor_contact_address"
                    id="vendor_contact_address"
                    placeholder="Enter vendor address"
                    value={settings.vendor_contact_address}
                    onChange={handleChange}
                    rows={3}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="customer_popup_checkout" sm={3}>
                  Enable Customer Popup
                </Label>
                <Col sm={9}>
                  <FormGroup check>
                    <Input
                      type="checkbox"
                      id="customer_popup_checkout"
                      name="customer_popup_checkout"
                      checked={settings.customer_popup_checkout}
                      onChange={handleChange}
                    />
                    <Label for="customer_popup_checkout">
                      Show customer popup during checkout
                    </Label>
                  </FormGroup>
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="allow_govt_discount" sm={3}>
                  Government Rounding
                </Label>
                <Col sm={9}>
                  <FormGroup check>
                    <Input
                      type="checkbox"
                      id="allow_govt_discount"
                      name="allow_govt_discount"
                      checked={settings.allow_govt_discount}
                      onChange={handleChange}
                    />
                    <Label for="allow_govt_discount">
                      Enable government rounding (rounds total to nearest nickel)
                    </Label>
                  </FormGroup>
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="vendor_social_facebook" sm={3}>
                  Facebook Page
                </Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="vendor_social_facebook"
                    id="vendor_social_facebook"
                    placeholder="Enter Facebook page URL"
                    value={settings.vendor_social_facebook}
                    onChange={handleChange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="vendor_social_tiktok" sm={3}>
                  TikTok Profile
                </Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="vendor_social_tiktok"
                    id="vendor_social_tiktok"
                    placeholder="Enter TikTok profile URL"
                    value={settings.vendor_social_tiktok}
                    onChange={handleChange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="vendor_social_twitter" sm={3}>
                  Twitter Profile
                </Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="vendor_social_twitter"
                    id="vendor_social_twitter"
                    placeholder="Enter Twitter profile URL"
                    value={settings.vendor_social_twitter}
                    onChange={handleChange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="vendor_social_youtube" sm={3}>
                  YouTube Channel
                </Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="vendor_social_youtube"
                    id="vendor_social_youtube"
                    placeholder="Enter YouTube channel URL"
                    value={settings.vendor_social_youtube}
                    onChange={handleChange}
                  />
                </Col>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Row>

      {/* CardKnox Payment Section */}
      <Row className="mb-4">
        <CardHeader>
          <CardTitle tag="h5">CardKnox Payment</CardTitle>
        </CardHeader>
        <CardBody>
          <Row className="g-3">
            <Col sm={12}>
              <FormGroup row>
                <Label for="ifields_key" sm={3}>
                  IFields Keys
                </Label>
                <Col sm={9}>
                  <Input
                    id="ifields_key"
                    type="text"
                    name="ifields_key"
                    value={settings.ifields_key}
                    onChange={handleChange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="cardknox_api_key" sm={3}>
                  API Key
                </Label>
                <Col sm={9}>
                  <Input
                    id="cardknox_api_key"
                    type="text"
                    name="cardknox_api_key"
                    value={settings.cardknox_api_key}
                    onChange={handleChange}
                  />
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label sm={3}>Use Tealbo API Key</Label>
                <Col sm={9}>
                  <FormGroup check>
                    <Input
                      type="checkbox"
                      id="cardknox_api_key_override"
                      name="cardknox_api_key_override"
                      checked={settings.cardknox_api_key_override}
                      onChange={handleChange}
                    />
                    <Label for="cardknox_api_key_override">
                      Override my API key and use Tealbo and commission will be
                      taken out base on our terms and conditions.
                    </Label>
                  </FormGroup>
                </Col>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Row>

      {/* Customer Points Section */}
      <Row className="mb-4">
        <CardHeader>
          <CardTitle tag="h5">Customer Points</CardTitle>
        </CardHeader>
        <CardBody>
          <Row className="g-3">
            <Col sm={12}>
              <FormGroup row>
                <Label for="points_usd_value" sm={3}>
                  Points USD Value
                </Label>
                <Col sm={9}>
                  <Input
                    id="points_usd_value"
                    type="text"
                    name="points_usd_value"
                    value={settings.points_usd_value}
                    onChange={handleChange}
                  />
                  <small className="form-text text-muted">
                    Set the USD value against 1 point customer spends into your
                    store
                  </small>
                </Col>
              </FormGroup>
            </Col>

            <Col sm={12}>
              <FormGroup row>
                <Label for="point_distribute_amount" sm={3}>
                  Points distribute amount
                </Label>
                <Col sm={9}>
                  <Input
                    id="point_distribute_amount"
                    type="text"
                    name="point_distribute_amount"
                    value={settings.point_distribute_amount}
                    onChange={handleChange}
                  />
                  <small className="form-text text-muted">
                    How many points a customer will get per dollar spend in your
                    store.
                  </small>
                </Col>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Row>

      {/* Single Save Button */}
      <Button type="submit" color="primary" className="mt-3">
        Save Settings
      </Button>
    </Form>
  );
}
